import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/grupos/groups";
import groups from "../../models/grupos/groups";
import groupsGt from "../../models/gestionTiempos/groups/groups";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    groups: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    openGroup: false,
    mode: "",
    openDelete: false,
    paddingNav: "300px",
    subGroups:[],
    newSubGroups:{},
    itemSelected:{}
  },

  mutations: {
    setGroups(state, data) {
      state.groups = data;
    },
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },

    setNew(state, data) {
      state.new = data;
    },
    setOpenGroup(state, data) {
      state.openGroup = data;
    },
    setMode(state, data) {
      state.mode = data;
    },

    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setSubGroups(state, data) {
      state.subGroups = data;
    },
    setNewSubGroups(state,data){
      state.newSubGroups = data;
    },
    setItemSelected(state,data){
      state.itemSelected = data;
    }

  },
  actions: {
    async getGroups(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getGroups();

          state.commit("setGroups", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSubGroups(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSubGroups();

          state.commit("setSubGroups", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            let item = state.state.edit;
            let options = state.state.groups;
            options = options.map((option) => {
              if (option.idSon != item.id) {
                return option;
              }
              item = groups.fromJson({
              padre: item.father,
              nombreP: item.fatherName,
              hijo: item.id,
              nombreH: item.name,
              nivel: item.level,
              });
              return item;
            });

            state.commit("setEdit", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(({ data }) => {
            let item = state.state.new;
            let options = state.state.groups;
            let newItem = groups.fromJson({
              padre: null,
              nombreP: null,
              hijo: data.grupoId,
              nombreH: item.group,
              nivel: 0,
            });
            options.push(newItem);

            state.commit("setGroups", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async newSubGroup(state) {
      return new Promise(async (resolve, reject) => {
        try {
        
          await state.state.service.newSubGroup( state.state.newSubGroups).then(({ data }) => {
            let item = state.state.newSubGroups;
            let options = state.state.groups;
            let newItem = groupsGt.fromJson({
              GrupoId: data.grupoId,
              Nombre: item.group,
            });
            options.push(newItem);

            state.commit("setGroups", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.groups;
            options = options.filter((option) => {
              return option.idSon != state.state.deleteItem.id;
            });
            state.commit("setGroups", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
 
});
